import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Tabs.css';

function Tabs({ tabs }) {
  const location = useLocation();
  console.log(location.pathname.endsWith(tabs.path) , 'pathname', tabs?.[0]?.path, location.pathname.split('/')[location.pathname.split('/').length - 1])

  return (
    <div className="tabs-container border-bottom">
      {tabs.map(tab => (
        <Link
          key={tab.path}
          to={tab.path}
          className={`tab ${location.pathname.split('/')[location.pathname.split('/').length - 1] == tab.path ? 'active-tab' : ''}`}
        >
          {tab.name}
        </Link>
      ))}
    </div>
  );
}

export default Tabs;
